import FeedbackButton from './FeedbackButton';
import { useSubmitNewsFeedback } from '@/hooks/V3/useSubmitNewsFeedback';
import { useParams } from 'react-router-dom';
import { logEvent } from '@/etc/firebase';

const SatisfyingButton = ({ isDashboard = false }) => {
  const { submitFeedback } = useSubmitNewsFeedback();
  const { group } = useParams();

  const handleClick = () => {
    submitFeedback('satisfying');

    logEvent('submit_news_feedback', {
      feedback: 'satisfying',
      targetPage: isDashboard ? 'pc_page' : group,
    });
  };

  return <FeedbackButton onClick={handleClick}>😊 좋아요</FeedbackButton>;
};

export default SatisfyingButton;
